<script lang="ts">
  import AutoPayForm from "@retailer/svelte/Payments/Settings/AutoPayForm.svelte";
  import Flash from "@shared/services/flashv2.js";
  import { paymentInstrumentsStore } from "@retailer/svelte/stores/PaymentInstrumentStore";
  import { autoPaySettingsStore } from "@retailer/svelte/stores/AutoPaySettingsStore";
  import * as AutoPaySettingsService from "@retailer/services/auto_pay_settings_service";

  export let updateShowUnsavedChangesAlert: (newValue: boolean) => void;

  const onSave = async (
    selectedPaymentInstrumentId: number,
    selectedDistributorIds: number[],
    useCredits: boolean,
  ) => {
    const onSuccess = () => {
      Flash.now({
        type: "success",
        header: "Auto pay settings updated",
        message: "All auto pay settings go into effect immediately.",
      });
    };

    if ($autoPaySettingsStore.autoPaySettings.id) {
      await AutoPaySettingsService.update(
        $autoPaySettingsStore.autoPaySettings.id,
        selectedPaymentInstrumentId,
        selectedDistributorIds,
        useCredits,
        onSuccess,
      );
    } else {
      await AutoPaySettingsService.create(
        selectedPaymentInstrumentId,
        selectedDistributorIds,
        useCredits,
        onSuccess,
      );
    }
  };

  $: allDistributorsUseDefaultCredits = $autoPaySettingsStore.autoPaySettings.distributors.every(
    d => d.distributor_uses_default_credit_selection,
  );
</script>

<AutoPayForm
  availablePaymentInstruments={$paymentInstrumentsStore.paymentInstruments}
  oldPaymentInstrumentId={$autoPaySettingsStore.autoPaySettings.payment_instrument_id}
  oldDistributors={$autoPaySettingsStore.autoPaySettings.distributors}
  oldUseCredits={$autoPaySettingsStore.autoPaySettings.use_credits}
  {allDistributorsUseDefaultCredits}
  {onSave}
  {updateShowUnsavedChangesAlert}
/>
